var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_6322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.75C15.9518 18.75 18.75 15.9518 18.75 12.5C18.75 9.04822 15.9518 6.25 12.5 6.25C9.04822 6.25 6.25 9.04822 6.25 12.5C6.25 15.9518 9.04822 18.75 12.5 18.75Z",
    fill: "#489FCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.74956C11.8097 3.74956 11.25 3.18984 11.25 2.49956V1.25C11.25 0.559717 11.8097 0 12.5 0C13.1903 0 13.75 0.559717 13.75 1.25V2.49956C13.75 3.18984 13.1903 3.74956 12.5 3.74956Z",
    fill: "#489FCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5714 6.67862C19.2515 6.67862 18.9317 6.5567 18.6876 6.3127C18.1993 5.82471 18.1993 5.03326 18.687 4.54498L19.5701 3.66133C20.0584 3.17305 20.85 3.17291 21.3383 3.66089C21.8266 4.14888 21.8266 4.94034 21.3389 5.42862L20.4557 6.31226C20.2116 6.55655 19.8912 6.67862 19.5714 6.67862Z",
    fill: "#489FCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7499 13.75H22.5005C21.8102 13.75 21.2505 13.1903 21.2505 12.5C21.2505 11.8097 21.8102 11.25 22.5005 11.25H23.7499C24.4402 11.25 24.9999 11.8097 24.9999 12.5C24.9999 13.1903 24.4402 13.75 23.7499 13.75Z",
    fill: "#489FCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4546 21.705C20.1348 21.705 19.8144 21.583 19.5702 21.3387L18.687 20.455C18.1993 19.9668 18.1993 19.1753 18.6876 18.6873C19.1759 18.1993 19.9675 18.1992 20.4557 18.6878L21.3389 19.5714C21.8266 20.0597 21.8266 20.8511 21.3384 21.3391C21.0942 21.5831 20.7744 21.705 20.4546 21.705Z",
    fill: "#489FCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C11.8097 25 11.25 24.4403 11.25 23.75V22.5004C11.25 21.8101 11.8097 21.2504 12.5 21.2504C13.1903 21.2504 13.75 21.8101 13.75 22.5004V23.75C13.75 24.4403 13.1903 25 12.5 25Z",
    fill: "#489FCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54548 21.705C4.22566 21.705 3.90584 21.5831 3.66169 21.3391C3.17341 20.8511 3.17341 20.0597 3.66111 19.5714L4.54431 18.6878C5.03259 18.1992 5.82424 18.1993 6.31252 18.6873C6.80081 19.1753 6.80081 19.9668 6.31311 20.455L5.42991 21.3387C5.18577 21.5828 4.86531 21.705 4.54548 21.705Z",
    fill: "#489FCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49941 13.75H1.25C0.559717 13.75 0 13.1903 0 12.5C0 11.8097 0.559717 11.25 1.25 11.25H2.49941C3.1897 11.25 3.74941 11.8097 3.74941 12.5C3.74941 13.1903 3.1897 13.75 2.49941 13.75Z",
    fill: "#489FCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42825 6.67861C5.10842 6.67861 4.78801 6.55654 4.54382 6.31225L3.66062 5.42861C3.17292 4.94033 3.17292 4.14887 3.66121 3.66088C4.14949 3.17289 4.94114 3.17275 5.42942 3.66132L6.31262 4.54496C6.80032 5.03325 6.80032 5.8247 6.31204 6.31269C6.0679 6.55668 5.74807 6.67861 5.42825 6.67861Z",
    fill: "#489FCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_6322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.2ba11c3c65288ca15b1a7bd18d7f7720.svg";
export { ForwardRef as ReactComponent };